import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Support = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m18.5 18.5-3.634-3.634M9.129 9.129 5.5 5.5m0 13 3.629-3.629m5.737-5.737L18.5 5.5M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-5 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.656 19.404A9.7 9.7 0 0 0 12 21.75a9.7 9.7 0 0 0 6.344-2.346l-3.557-3.557A4.73 4.73 0 0 1 12 16.75a4.73 4.73 0 0 1-2.786-.903zm-1.06-1.06A9.7 9.7 0 0 1 2.25 12a9.7 9.7 0 0 1 2.346-6.344l3.557 3.557A4.73 4.73 0 0 0 7.25 12a4.73 4.73 0 0 0 .903 2.787zm1.06-13.748A9.7 9.7 0 0 1 12 2.25a9.7 9.7 0 0 1 6.344 2.346l-3.557 3.557A4.73 4.73 0 0 0 12 7.25a4.73 4.73 0 0 0-2.786.903zm13.748 1.06A9.7 9.7 0 0 1 21.75 12a9.7 9.7 0 0 1-2.346 6.344l-3.557-3.558A4.73 4.73 0 0 0 16.75 12a4.73 4.73 0 0 0-.903-2.787zM8.75 12a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 0 0-6.5 0'
        fill='currentColor'
      />
    )}
  </IconBase>
);
